import { render, staticRenderFns } from "./projectCard.vue?vue&type=template&id=38556d25&"
import script from "./projectCard.vue?vue&type=script&lang=js&"
export * from "./projectCard.vue?vue&type=script&lang=js&"
import style0 from "./projectCard.vue?vue&type=style&index=0&id=38556d25&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports